import { lazyLoad } from 'utils/loadable';

export const NewUnitWrapperLoadable = lazyLoad(
  () => import('./NewUnitWrapper'),
  module => module.NewUnitWrapper,
);
